window.initDelayRender = function (hideClassName) {
  /*
  * @description 重置flickity轮播
  * param { flickityElm: HtmlElement } flickity轮播dom元素
  */
  function flickityResize (flickityElm) {
    var flickityIns = flickityElm 
      ? new Flickity(flickityElm, {
        cellAlign: 'left',
        contain: true
      })
      : undefined
    flickityIns && flickityIns.resize()
  }

  /*
   * @description 判断延时dom下面子元素是否包含flickity轮播
   * @param { elm: HtmlElement } 延时dom元素
  */
  function isContainFlickity (elm) {
    return elm.querySelector('.ProductList')
  }

  /*
   * @description 展示延时dom
   * @param { elm: HtmlElement } 延时dom元素
  */
  function showDelayDom (elm) {
    if (elm) {
      elm.classList.remove(hideClassName)
      var flickityElm = isContainFlickity(elm)
      if (flickityElm) {
        flickityResize(flickityElm)
      }
    }
  }

  /*
   * @description 处理延时dom处理
   * @param { isReload: boolean } 是否是局部刷新
   */
  function handlerDelayDom (isReload) {
    var allNetHideElms = document.querySelectorAll('.'+hideClassName) || []
    // 局部刷新处理
    function partialReload (elm) {
      showDelayDom(elm)
    }

    // 绑定延时dom处理
    function bindDelaydomHandler (elm) {
      var seconds = elm.getAttribute('delay')
      if (seconds) {
        setTimeout(function () {showDelayDom(elm)}, seconds)
      } else {
        document.addEventListener('DOMContentLoaded',function(){
          showDelayDom(elm)
        });
      }
    }
    allNetHideElms.forEach(elm => {
      if (elm instanceof HTMLElement) {
        isReload ? partialReload(elm) : bindDelaydomHandler(elm)
      }
    })
  }

  /*
  * @description 绑定局部刷新的回调
  */
  function bindReloadCallback () {
    window.refreshCallbacks = window.refreshCallbacks || []
    window.refreshCallbacks.push(function () {handlerDelayDom(true)})
  }

  bindReloadCallback()
  handlerDelayDom()
}
